import { createAction } from 'redux-actions';

export const signIn         = createAction('SIGN_IN');
export const setCurrentUser = createAction('SET_CURRENT_USER');
